import React from 'react';
import ProductSidebarComponent from './ProductSidebarComponent';
import { PageHeader } from '../../components';

const AmcOfWaterWastewaterTreatmentPlants: React.FC = () => {
  return (
    <>
      <PageHeader customClass='bg-breadcrumb-om' title="Annual Maintenance Contracts (AMC) – Water & Wastewater Treatment Plants" breadcrumbs={[{ label: "Products", path: "/products" }]} />

      <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s"
        style={{ visibility: "visible", animationDelay: "0.1s", animationName: "fadeInUp" }}>
        <div className="container">
          <div className="row g-5">

            <div className="col-lg-8">
              <div className="row g-3 mb-5">
                <div className="col-md-6">
                  <img className="img-fluid" src="img/industrial-3.jpg" alt="" />
                </div>
                <div className="col-md-6">
                  <img className="img-fluid" src="img/industrial-1.jpg" alt="" />
                </div>
              </div>
              <h1 className="mb-4">Annual Maintenance Contracts (AMC) – Water & Wastewater Treatment Plants</h1>
              
              <h3 className="mb-4">Overview</h3>
              <p>To ensure uninterrupted and efficient operation of water and wastewater treatment systems, Annual Maintenance Contracts (AMC) offer a structured and proactive approach to service and support. At Wasser Technochem (I) Ltd., we provide comprehensive AMC solutions for WTPs, STPs, ETPs, ZLD systems, RO plants, and utility systems, tailored to meet the operational demands and compliance requirements of Indian industries and municipalities.</p>
              <p>With a strong track record of preventive maintenance and on-call technical support, WTIL's AMC services help clients avoid breakdowns, extend equipment life, and reduce total cost of ownership.</p>

              <h3 className="mb-4">Scope of Services</h3>
              <div className="row g-4 mb-4">
                <div className="col-md-6">
                  <p><i className="fa fa-calendar-check text-primary me-2"></i>Preventive and scheduled maintenance</p>
                </div>
                <div className="col-md-6">
                  <p><i className="fa fa-tools text-primary me-2"></i>Mechanical, electrical, and instrumentation service</p>
                </div>
                <div className="col-md-6">
                  <p><i className="fa fa-sync text-primary me-2"></i>Membrane cleaning, resin regeneration, pump overhauling</p>
                </div>
                <div className="col-md-6">
                  <p><i className="fa fa-tachometer-alt text-primary me-2"></i>Calibration of pH/ORP/TDS meters, flow meters, and analyzers</p>
                </div>
                <div className="col-md-6">
                  <p><i className="fa fa-search text-primary me-2"></i>Root-cause analysis for repeated faults or underperformance</p>
                </div>
                <div className="col-md-6">
                  <p><i className="fa fa-exclamation-triangle text-primary me-2"></i>Emergency breakdown response</p>
                </div>
                <div className="col-md-6">
                  <p><i className="fa fa-boxes text-primary me-2"></i>Spare parts inventory management and support</p>
                </div>
                <div className="col-md-6">
                  <p><i className="fa fa-chart-line text-primary me-2"></i>Monthly health reports and technical recommendations</p>
                </div>
              </div>

              <h3 className="mb-4">Coverage</h3>
              <div className="row g-4 mb-4">
                <div className="col-md-6">
                  <div className="service-item">
                    <div className="overflow-hidden">
                      <h5><i className="fa fa-tint text-primary me-2"></i>RO Plants</h5>
                      <p>Reverse Osmosis Plants (UF, NF, SWRO, Brackish RO)</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="service-item">
                    <div className="overflow-hidden">
                      <h5><i className="fa fa-filter text-primary me-2"></i>DM & Softening</h5>
                      <p>Demineralization and Softening Systems</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="service-item">
                    <div className="overflow-hidden">
                      <h5><i className="fa fa-recycle text-primary me-2"></i>ETP/STP/ZLD</h5>
                      <p>ETP/STP/ZLD plants with MBBR, SBR, MBR, MEE/ATFD systems</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="service-item">
                    <div className="overflow-hidden">
                      <h5><i className="fa fa-shield-alt text-primary me-2"></i>Filtration & Disinfection</h5>
                      <p>Filtration and disinfection systems</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="service-item">
                    <div className="overflow-hidden">
                      <h5><i className="fa fa-microchip text-primary me-2"></i>Support Systems</h5>
                      <p>Pump houses, chemical dosing stations, and SCADA panels</p>
                    </div>
                  </div>
                </div>
              </div>

              <h3 className="mb-4">Benefits</h3>
              <div className="row g-4 mb-5">
                <div className="col-md-6">
                  <h5><i className="fa fa-check-circle text-success me-2"></i>Guaranteed Uptime</h5>
                  <p>Ensures plant uptime with planned maintenance</p>
                </div>
                <div className="col-md-6">
                  <h5><i className="fa fa-check-circle text-success me-2"></i>Reduced Breakdowns</h5>
                  <p>Reduces costly emergency breakdowns</p>
                </div>
                <div className="col-md-6">
                  <h5><i className="fa fa-check-circle text-success me-2"></i>OEM-Level Service</h5>
                  <p>Access to OEM-equivalent servicing and support</p>
                </div>
                <div className="col-md-6">
                  <h5><i className="fa fa-check-circle text-success me-2"></i>Performance Audits</h5>
                  <p>Performance audits with compliance verification</p>
                </div>
                <div className="col-md-12">
                  <h5><i className="fa fa-check-circle text-success me-2"></i>Cost Predictability</h5>
                  <p>Annual budgeting and cost predictability for O&M</p>
                </div>
              </div>

              <h3 className="mb-4">Why WTIL?</h3>
              <div className="row g-4">
                <div className="col-md-12">
                  <div className="d-flex">
                    <div className="flex-shrink-0 btn-square bg-primary rounded-circle" style={{ width: "64px", height: "64px" }}>
                      <i className="fa fa-handshake text-white"></i>
                    </div>
                    <div className="ms-4">
                      <h5>Tailored SLAs</h5>
                      <p className="mb-0">Tailored Service Level Agreements on monthly/quarterly/visit basis</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="d-flex">
                    <div className="flex-shrink-0 btn-square bg-primary rounded-circle" style={{ width: "64px", height: "64px" }}>
                      <i className="fa fa-building text-white"></i>
                    </div>
                    <div className="ms-4">
                      <h5>Diverse Client Experience</h5>
                      <p className="mb-0">AMC experience with both private and public sector clients</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="d-flex">
                    <div className="flex-shrink-0 btn-square bg-primary rounded-circle" style={{ width: "64px", height: "64px" }}>
                      <i className="fa fa-users-cog text-white"></i>
                    </div>
                    <div className="ms-4">
                      <h5>Multi-Vendor Expertise</h5>
                      <p className="mb-0">Technicians trained in multi-vendor systems and automation platforms</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="d-flex">
                    <div className="flex-shrink-0 btn-square bg-primary rounded-circle" style={{ width: "64px", height: "64px" }}>
                      <i className="fa fa-phone-alt text-white"></i>
                    </div>
                    <div className="ms-4">
                      <h5>Dedicated Support</h5>
                      <p className="mb-0">Dedicated support team and escalation matrix</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="d-flex">
                    <div className="flex-shrink-0 btn-square bg-primary rounded-circle" style={{ width: "64px", height: "64px" }}>
                      <i className="fa fa-link text-white"></i>
                    </div>
                    <div className="ms-4">
                      <h5>Integrated Solutions</h5>
                      <p className="mb-0">Access to WTIL's chemical, spares, and manpower integration</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="d-flex">
                    <div className="flex-shrink-0 btn-square bg-primary rounded-circle" style={{ width: "64px", height: "64px" }}>
                      <i className="fa fa-medal text-white"></i>
                    </div>
                    <div className="ms-4">
                      <h5>Performance Guarantee</h5>
                      <p className="mb-0">Performance-linked SLAs for guaranteed service quality</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4">
              <ProductSidebarComponent />
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default AmcOfWaterWastewaterTreatmentPlants;
